const NavigationType = {
    Default : 0,
    Next : 1,
    Previous : 2

};

export default NavigationType;